import { Meta } from '@storybook/addon-docs';

<Meta title="Home" />

# Ignite UI

Design System do Ignite.